import React, { useState, useEffect } from 'react';
import ApplicantList from './ManagerPanels/Applicant';
import Topic from './ManagerPanels/Topic';
import TabMenu from './Common/TabMenu';
import TabMenuNav from './Common/TabMenuNav';
import UserAccountManagement from './ManagerPanels/UserAccountManagement';
import MenuListManagement from './ManagerPanels/MenuListManagement';
import MenuSetting from './ManagerPanels/MenuSetting';
import VersionSetting from './ManagerPanels/VersionSetting';
import QA from './ManagerPanels/QA';
import EditorSetting from './ManagerPanels/EditorSetting';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import HoverMenu from './Common/HoverMenu';
import AdminManagement from './ManagerPanels/AdminManagement';
import AccessManagement from './ManagerPanels/AccessManagement';
import ProductsManagement from './ManagerPanels/ProductsManagement';

const Admin = () => {
    const history = useNavigate();
    const LoginStates = useSelector(state => state.login);
    const [menuData, setMenuData] = useState([]);
    const [mainRoute, setMainRoute] = useState('');
    const [subRoute, setSubRoute] = useState('');
    const [tabContent, setTabContent] = useState(null);
    const [selectedType, setSelectedType] = useState("user");

    const [state, setState] = useState({
        menu: [],
        submenu: [],
        current: ''
    });

    useEffect(() => {
        if (LoginStates.userId !== "" && !checkAdmin()) {
            history("/")
        }
    }, [LoginStates]);

    useEffect(() => {
        fetchMenuData();
    }, []);

    useEffect(() => {
        getAdminList();
    }, [LoginStates.admin]);

    useEffect(() => {
        setTabContent(loadTabContent());
    }, [state.current, mainRoute, subRoute]);

    useEffect(() => {
        if (selectedType === 'menu' && menuData && menuData.length > 0) {
            const mainRoute = menuData[0].route;
            const subRoute = menuData[0].submenu.length > 0 ? menuData[0].submenu[0].route : '';
            handleClick(mainRoute, subRoute);
        }
    }, [selectedType]);

    const fetchMenuData = async () => {
        try {
            const response = await fetch('datas/menu/menu.json');
            const data = await response.json();
            if (data.length > 0) {
                setMenuData(data);
                setMainRoute(data[0].submenu ? data[0].route : "document");
                setSubRoute(data[0].submenu?.[0]?.route || '');
            }
        } catch (error) {
            console.error("Failed to fetch menu data", error);
        }
    };

    const handleClick = (main, sub) => {
        setMainRoute(main);
        setSubRoute(sub);
        handlePanels('MenuSetting');
    };

    const handlePanels = (mode) => {
        setState(prev => ({ ...prev, current: mode }));
    };

    const handleTypeClick = (type) => {
        setSelectedType(type);
    };

    const getAdminList = async () => {
        const response = await fetch('./datas/oper/admin_menu.json');
        const json = await response.json();

        const auth = LoginStates?.admin || "";
        const spllitauth = auth.split(",");

        const submenu = [];
        const menu = [];

        for (let group of json) {
            const type = group.id;
            const groupTitle = group.title;

            const matchedSubmenus = group.submenu.filter(sub =>
                sub.auth.some(a => spllitauth.includes(a))
            );

            if (matchedSubmenus.length > 0) {
                for (let sub of matchedSubmenus) {
                    if (!submenu.find(d => d.id === sub.id)) {
                        submenu.push({
                            ...sub,
                            type
                        });
                    }
                }

                menu.push({
                    id: type,
                    title: groupTitle
                });
            }
        }

        setState({
            menu,
            submenu,
            current: submenu[0]?.id || ''
        });
    };

    const loadTabContent = () => {
        switch (state.current) {
            case 'Authorization': return <div className="content"><h2>권한신청관리</h2></div>;
            case 'TopicList': return <Topic current='topicList' isAdmin={true} />;
            case 'UserAccountList': return <UserAccountManagement />;
            case 'Applicant': return <ApplicantList />;
            case 'AdminList': return <AdminManagement />;
            case 'ProductsList': return <ProductsManagement />;
            case 'MenuList': return <MenuListManagement />;
            case 'AccessList': return <AccessManagement />;
            case 'MenuSetting': return <MenuSetting userId={LoginStates.userId} menuData={menuData} mainRoute={mainRoute} subRoute={subRoute} />;
            case 'VersionSetting': return <VersionSetting />;
            case 'QAProgress': return <QA type='progress' />;
            case 'QAComplete': return <QA type='complete' />;
            case 'EditorSetting': return <EditorSetting />;
            default: return null;
        }
    };

    const checkAdmin = () => {
        return LoginStates.admin?.replace(/,/g, "") !== '';
    };

    return (
        <div className="admin">
            <div className="admin-wrap">
                <header>
                    <TabMenuNav
                        menu={state.menu}
                        type={selectedType}
                        onTypeClick={handleTypeClick}
                    />
                    <TabMenu
                        type={selectedType}
                        title=""
                        menuData={menuData}
                        mainMenu={state.menu}
                        subMenu={state.submenu}
                        current={state.current}
                        clickMenu={handlePanels}
                        onClickRoute={handleClick}
                    />
                </header>                
                {state.current === "MenuSetting" &&
                    <HoverMenu 
                        menuData={menuData}
                        onClickRoute={handleClick}
                    />
                }
                {tabContent}
            </div>
        </div>
    );
};

export default Admin;